import jssVariables from "../../jss_setup";

export const footer = {
  footerContainer: {
    paddingTop: 0,
  },
  footer: {
    paddingBottom: jssVariables.navbar_height,
  },
};
